import Vue from "vue";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import echarts from 'echarts'
import "./assets/css/normalize.css"
import "./assets/css/animation.css"
import "./assets/css/common.css"
import "./style/index.scss"
import 'swiper/swiper-bundle.css';
import SIdentify from './components/Canvas/Canvas.vue'
import Tabbar from "@/components/Nav/Nav.vue";
import Header from "@/components/Header/index.vue";
import Foot from "@/components/foot/Foot.vue";
import "./style/MyukiGCard.css"
Vue.component('Tabbar', Tabbar)
Vue.component('Header', Header)
Vue.component('Foot', Foot)
Vue.use(ElementUI);
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;
Vue.component('s-identify', SIdentify)
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
//or you can set componentName default componentName is vue-seamless-scroll
Vue.use(scroll, { componentName: 'scroll-seamless' })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

router.afterEach(() => {
  window.scrollTo(0,0);
});
